"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishlistStorage = void 0;
var cookie_storage_item_1 = require("./cookie-storage-item");
var json_storage_item_1 = require("./json-storage-item");
var WishlistStorage = (function () {
    function WishlistStorage() {
        this.key = 'evelin.wishlist';
        this.maxLength = 99;
        this.oneYearInSeconds = 60 * 60 * 24 * 365;
        this.storage = new json_storage_item_1.JsonStorageItem(new cookie_storage_item_1.CookieStorageItem(this.key, this.oneYearInSeconds));
    }
    WishlistStorage.prototype.get = function () {
        var _a;
        return ((_a = this.storage.get()) === null || _a === void 0 ? void 0 : _a.slice(0, this.maxLength)) || [];
    };
    WishlistStorage.prototype.add = function (productId) {
        var wishlistProductIds = new Set(__spreadArray([productId], this.get(), true));
        if (wishlistProductIds.size > this.maxLength) {
            throw new Error('Maximum Item Count exceeded');
        }
        this.storage.set(Array.from(wishlistProductIds));
    };
    WishlistStorage.prototype.remove = function (productId) {
        this.removeMultiple([productId]);
    };
    WishlistStorage.prototype.removeMultiple = function (productIds) {
        var wishlistProductIds = new Set(this.get());
        productIds.forEach(function (productId) { return wishlistProductIds.delete(productId); });
        this.storage.set(Array.from(wishlistProductIds));
    };
    WishlistStorage.prototype.clear = function () {
        this.storage.remove();
    };
    return WishlistStorage;
}());
exports.WishlistStorage = WishlistStorage;
//# sourceMappingURL=wishlist-storage.js.map